(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  class HeroSlider extends HTMLElement {
    constructor() {
      super();
      this.slides = this.querySelectorAll('.hero-slider__slide');
      this.dots = this.querySelectorAll('.hero-slider__dot');
      this.currentIndex = 0;
      this.autoRotate = this.dataset.autoRotate === 'true';
      this.rotateSpeed = parseInt(this.dataset.rotateSpeed) * 1000 || 5000;
      this.autoRotateInterval = null;
      this.isAnimating = false;
    }

    connectedCallback() {
      if (this.slides.length <= 1) return;

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          if (index !== this.currentIndex) {
            const direction = index > this.currentIndex ? 'left' : 'right';
            this.goToSlide(index, direction);
          }
        });
      });

      const prevButton = this.querySelector('[data-hero-prev]');
      const nextButton = this.querySelector('[data-hero-next]');
      if (prevButton) prevButton.addEventListener('click', () => this.prevSlide());
      if (nextButton) nextButton.addEventListener('click', () => this.nextSlide());

      if (this.autoRotate) {
        this.startAutoRotate();
        this.addEventListener('mouseenter', () => this.stopAutoRotate());
        this.addEventListener('mouseleave', () => this.startAutoRotate());
      }

      let touchStartX = 0;
      let touchEndX = 0;

      this.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      this.addEventListener('touchend', (e) => {
        touchEndX = e.changedTouches[0].screenX;
        this.handleSwipe(touchStartX, touchEndX);
      }, { passive: true });
    }

    handleSwipe(startX, endX) {
      const threshold = 50;
      const diff = startX - endX;

      if (Math.abs(diff) > threshold) {
        if (diff > 0) {
          this.nextSlide();
        } else {
          this.prevSlide();
        }
      }
    }

    goToSlide(index, direction = 'left') {
      if (this.isAnimating || index === this.currentIndex) return;
      this.isAnimating = true;

      const currentSlide = this.slides[this.currentIndex];
      const nextSlide = this.slides[index];

      currentSlide.classList.remove('active');
      if (direction === 'left') {
        currentSlide.classList.add('slide-out-left');
        nextSlide.classList.add('slide-in-right');
      } else {
        currentSlide.classList.add('slide-out-right');
        nextSlide.classList.add('slide-in-left');
      }

      this.dots[this.currentIndex].classList.remove('active');
      this.dots[this.currentIndex].setAttribute('aria-selected', 'false');

      void nextSlide.offsetWidth;

      nextSlide.classList.remove('slide-in-left', 'slide-in-right');
      nextSlide.classList.add('active');

      this.dots[index].classList.add('active');
      this.dots[index].setAttribute('aria-selected', 'true');

      setTimeout(() => {
        currentSlide.classList.remove('slide-out-left', 'slide-out-right');
        this.currentIndex = index;
        this.isAnimating = false;
      }, 600);
    }

    nextSlide() {
      const nextIndex = (this.currentIndex + 1) % this.slides.length;
      this.goToSlide(nextIndex, 'left');
    }

    prevSlide() {
      const prevIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
      this.goToSlide(prevIndex, 'right');
    }

    startAutoRotate() {
      this.stopAutoRotate();
      this.autoRotateInterval = setInterval(() => this.nextSlide(), this.rotateSpeed);
    }

    stopAutoRotate() {
      if (this.autoRotateInterval) {
        clearInterval(this.autoRotateInterval);
        this.autoRotateInterval = null;
      }
    }

    disconnectedCallback() {
      this.stopAutoRotate();
    }
  }

  if (!customElements.get('hero-slider')) {
    customElements.define('hero-slider', HeroSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
